<script setup lang="ts">
defineProps<{
  shown: boolean
  active: boolean
}>()

const emit = defineEmits<{
  close: []
  continue: []
}>()
</script>

<template>
  <div
    class="modal fade"
    id="SubjectSelectedConfirmModal"
    :class="{ show: shown }"
    :style="{ display: active ? 'block' : 'none' }"
    role="dialog"
    aria-modal="true"
  >
    <div class="modal-dialog modal-lg" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h4 class="modal-title">Confirm Subjects</h4>
          <button type="button" class="modal-close" aria-label="Close" @click="emit('close')">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <div class="alert alert-danger">
            <h3>Have you selected all the La Trobe subjects you want?</h3>
            <p>
              Please ensure the subject codes in the "La Trobe Code" column are the subjects you want to receive credit for.
              If there is an UNSPECIFIED CREDIT code listed (e.g. U1.015.000) this credit can only be used as an elective.
              If you want credit for a core subject please search the <a class="HandbookLink" target="'_blank">University Handbook</a>
              for the desired subject and enter it above by clicking the "Request a different La Trobe subject" button.
            </p>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-primary" @click="emit('close')">No, go back</button>
          <button type="button" class="btn btn-danger" id="SubjectSelectedConfirmModalBtn" @click="emit('continue')">Yes, I have</button>
        </div>
      </div>
    </div>
  </div>
</template>
